import styled from 'styled-components';

const SnackbarContainer = styled.div`
  display: flex;
  max-width: 440px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-Margin-Margin4, 12px) 16px;
  border-radius: var(--radius-Small, 8px);
  background: rgba(229, 216, 255, 0.6);
  box-shadow: 0px 0px 4px 0px rgba(18, 18, 18, 0.08);
  backdrop-filter: blur(10px);
  gap: var(--spacing-Margin-Margin3, 8px);
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-Margin-Margin3, 8px);
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--spacing-Margin-Margin2, 4px);
`;

// TODO: 디자인 시스템 적용 필요 Body/Body4
const Title = styled.p`
  color: var(--color-text-primary, #8424ea);
  font-family: var(--typography-font-Main, SUIT);
  font-size: var(--typography-size-Size14, 14px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--typography-lineHeight-LineHeight18, 18px);
  letter-spacing: var(--typography-letterSpace-Regular, 0px);
`;

// TODO: 디자인 시스템 적용 필요 Body/Body8
const Description = styled.p`
  color: var(--color-text-basic, #121212);
  font-family: var(--typography-font-Main, SUIT);
  font-size: var(--typography-size-Size12, 12px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--typography-lineHeight-LineHeight14, 14px);
  letter-spacing: var(--typography-letterSpace-Regular, 0px);

  // TODO: 디자인 시스템 적용 필요 Body/Body7
  & strong {
    color: var(--color-text-primary, #8424ea);
    font-family: var(--typography-font-Main, SUIT);
    font-size: var(--typography-size-Size12, 12px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--typography-lineHeight-LineHeight14, 14px);
    letter-spacing: var(--typography-letterSpace-Regular, 0px);
  }

  & b {
    color: var(--color-text-basic, #121212);
    font-family: var(--typography-font-Main, SUIT);
    font-size: var(--typography-size-Size12, 12px);
    font-style: normal;
    font-weight: 700;
    line-height: var(--typography-lineHeight-LineHeight14, 14px);
    letter-spacing: var(--typography-letterSpace-Regular, 0px);
  }
`;

const ButtonWrapper = styled.div`
  & button {
    display: flex;
    padding: var(--spacing-Margin-Margin3, 8px);
    justify-content: center;
    align-items: center;
    gap: var(--spacing-Margin-Margin0, 0px);
    border-radius: var(--radius-XSmall, 4px);
    border: none;
    background: var(--color-button-background-full_primary_default, #8424ea);

    /* TODO: 디자인 시스템 적용 필요 Body/Body8 */
    color: var(--color-text-reverse, #fff);
    text-align: center;
    font-family: var(--typography-font-Main, SUIT);
    font-size: var(--typography-size-Size12, 12px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--typography-lineHeight-LineHeight14, 14px);
    letter-spacing: var(--typography-letterSpace-Regular, 0px);
  }
`;

const RemainTimeContainer = styled.div`
  display: flex;
  padding: var(--spacing-Margin-Margin3, 8px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-Margin-Margin1, 2px);
  border-radius: var(--radius-XSmall, 4px);
  border: 1px solid var(--color-primary-300, #cca8f7);

  @media (max-width: 357px) {
    flex-wrap: wrap;
    width: min-content;
  }
`;

const RemainTimeTextContainer = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RemainTimeTextWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
`;

// TODO: 디자인 시스템 적용 필요 Body/Body7
const RemainTimeText = styled.span`
  color: var(--color-text-primary, #8424ea);
  font-family: var(--typography-font-Main, SUIT);
  font-size: var(--typography-size-Size12, 12px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--typography-lineHeight-LineHeight14, 14px);
  letter-spacing: var(--typography-letterSpace-Regular, 0px);
  text-align: center;
`;

const DailyAttendanceSnackbarStyled = {
  SnackbarContainer,
  TextContainer,
  TextWrapper,
  Title,
  Description,
  ButtonWrapper,
  RemainTimeContainer,
  RemainTimeTextContainer,
  RemainTimeTextWrapper,
  RemainTimeText,
};

export default DailyAttendanceSnackbarStyled;
